import React from "react";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import { INVOICE } from "../../../route/paths";
import { showToast } from "../../../utils/utils";
import {
  MODAL,
  REDIRECT,
  showToastType
} from "../../../utils/constants/appConstants";

const AccountingSoftwareButton = ({
  type,
  logo,
  alt,
  width,
  height,
  authorizeFn,
  redirectKey,
  onClickModal
}) => {
  const navigate = useNavigate();

  const getValueFromPath = (obj, path) =>
    path?.split(".").reduce((acc, key) => acc?.[key], obj);

  const handleRedirect = async () => {
    try {
      const response = await authorizeFn();
      const redirectUrl = getValueFromPath(response, redirectKey);
      redirectUrl ? (window.location.href = redirectUrl) : navigate(INVOICE);
    } catch (error) {
      showToast(error?.response?.data?.message, showToastType.error);
    }
  };

  const handleClick = () => {
    if (type === MODAL) return onClickModal();
    handleRedirect();
  };

  return (
    <div className="col-md-6 text-center d-flex justify-content-center align-items-center">
      <Link to="" onClick={handleClick}>
        <img src={logo} alt={alt} width={width} height={height} />
      </Link>
    </div>
  );
};

AccountingSoftwareButton.propTypes = {
  type: PropTypes.oneOf([MODAL, REDIRECT]).isRequired,
  logo: PropTypes.string.isRequired,
  alt: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  authorizeFn: PropTypes.func,
  redirectKey: PropTypes.string,
  onClickModal: PropTypes.func
};

export default AccountingSoftwareButton;
